//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import remarkDialog from "./OrderPop/Remark.vue";
import cancelDialog from "./OrderPop/CancelOrder.vue";
import logisticsDialog from "./OrderPop/Logistics.vue";
export default {
  data() {
    return {
      filterForm: {
        orderNum: "",
        goodsName: "",
        orderStatus: "",
        user: "",
        supplierName: "",
        brandName: "",
        buyer: "",
        orderSource: "",
        mode: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
      },
      currentPage: 1,
      dateRange: [],
      tabCur: "80",
      expands: [],
      orderList: [
        {
          name: "村集体",
          id: "1",
        },
        {
          name: "合作社",
          id: "2",
        },
      ],
      sourceList: [
        {
          name: "自主下单",
          id: "0",
        },
        {
          name: "运营后台下单",
          id: "1",
        },
      ],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
        loading: false,
      },
      total: 0,
      orderTabList: [],
      remarkStatus: false,
      checkStatus: false,
      logisticsStatus: "",
      orderId: "",
      dateArr: [],
    };
  },
  components: {
    remarkDialog,
    cancelDialog,
    logisticsDialog,
  },
  filters: {
    filterStatus(val) {
      if (val == 10) {
        return "待议价";
      } else if (val == 20) {
        return "待付款";
      } else if (val == 30) {
        return "待确认付款";
      } else if (val == 40) {
        return "待发货";
      } else if (val == 50) {
        return "已发货";
      } else if (val == 60) {
        return "已完成";
      } else if (val == 0) {
        return "已取消";
      }
    },
    filterPayStatus(val) {
      if (val == 0) {
        return "自主下单";
      } else if (val == 1) {
        return "运营后台下单";
      }
    },
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    handleFilter() {
      this.getOrderList();
    },
    getOrderList() {
      if (this.dateArr != null) {
        if (this.dateArr[0] != undefined) {
          this.filterForm.startTime = this.dateArr[0] + " " + "00:00:00";
        } else {
          this.filterForm.startTime = "";
        }

        if (this.dateArr[1] != undefined) {
          this.filterForm.endTime = this.dateArr[1] + " " + "23:59:59";
        } else {
          this.filterForm.endTime = "";
        }
      }
      this.filterForm.pageNum = this.currentPage;
      this.$http.szOrder.getOrderPage(this.filterForm).then((res) => {
        if (res.status == 1) {
          this.orderTabList = res.data;
          this.total = res.count;
        }
      });
    },
    pickerChangeFn() {
      if (this.dateArr == null) {
        this.filterForm.startTime = "";
        this.filterForm.endTime = "";
      }
    },
    handleChange(val) {
      this.filterForm.orderSource = val;
    },
    handleChangePay(val) {
      this.filterForm.mode = val;
    },
    handleClick(tab) {
      if (tab.name == 80) {
        this.filterForm.orderStatus = "";
      } else {
        this.filterForm.orderStatus = tab.name;
      }
      this.currentPage = 1;
      this.filterForm.pageNum = 1;
      this.getOrderList();
    },
    handleReset() {
      this.filterForm.orderNum = "";
      this.filterForm.goodsName = "";
      this.filterForm.user = "";
      this.filterForm.supplierName = "";
      this.filterForm.brandName = "";
      this.filterForm.buyer = "";
      this.filterForm.orderSource = "";
      this.filterForm.mode = "";
      this.filterForm.endTime = "";
      this.filterForm.startTime = "";
      this.dateArr = [];
      this.$nextTick(() => {
        this.getOrderList();
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOrderList();
    },
    goDetail(id, status) {
      let path = "/szoperation/order/details";
      this.$router.push({
        path,
        query: {
          id: id,
          orderStatus: status,
          flag: 1,
        },
      });
    },
    // 查看物流信息
    checkLogistics(id) {
      this.orderId = id;
      this.logisticsStatus = true;
    },

    getCloseStatus(val) {
      if (val == true) {
        this.remarkStatus = false;
        this.checkStatus = false;
        this.logisticsStatus = false;
        this.getOrderList();
      }
    },
    // 订单备注
    handleRemark(id) {
      this.remarkStatus = true;
      this.orderId = id;
    },
    // 取消订单
    cancelOrder(id) {
      this.checkStatus = true;
      this.orderId = id;
      s;
    },
  },
};
